import { useCallback } from "react";

import useTranslations from "@/shared/lang/useTranslations";

import { BATCH_ERROR_CODE_LABEL_KEYS } from "../constants/payoutBatches.constants";
import type { BatchError } from "../utils/batchErrors";

/**
 * The sentence to show for a classified batch error: our own copy when the backend sent a code we know, the
 * backend's localized sentence otherwise, and a generic line when the request never got an answer.
 */
export function useBatchErrorMessage(): (error: BatchError) => string {
  const { t } = useTranslations("payoutBatches");
  return useCallback(
    (error: BatchError) => {
      const key = error.code ? BATCH_ERROR_CODE_LABEL_KEYS[error.code] : undefined;
      if (key) return t(key);
      if (error.kind === "verification_required") return t("error_verification_required");
      if (error.kind === "network") return t("error_network");
      return error.message || t("error_generic");
    },
    [t],
  );
}
